import { AxiosResponse } from 'axios';

import apiClient from './client';
import { ApiResponseDto } from 'interfaces/apiResponse';
import { InvoiceSeriesDto } from 'interfaces/invoiceSeries';

interface InvoiceSeriesCreateRequestDto {
  name: string;
  isDefault: boolean;
  nextInvoiceNumber?: number;
}

interface InvoiceSeriesUpdateRequestDto {
  name?: string;
  isDefault?: boolean;
  nextInvoiceNumber?: number;
}

interface InvoicingSeriesService {
  getAll(): Promise<InvoiceSeriesDto[]>;
  create(data: InvoiceSeriesCreateRequestDto): Promise<InvoiceSeriesDto>;
  update(id: number, data: InvoiceSeriesUpdateRequestDto): Promise<InvoiceSeriesDto>;
  activate(id: number): Promise<InvoiceSeriesDto>;
  deactivate(id: number): Promise<InvoiceSeriesDto>;
}

const endpoints = {
  series: '/tenant/invoicing/series',
  seriesById: (id: number) => `/tenant/invoicing/series/${id}`,
  deactivate: (id: number) => `/tenant/invoicing/series/${id}/deactivate`,
  activate: (id: number) => `/tenant/invoicing/series/${id}/activate`,
};

export const invoicingSeriesService: InvoicingSeriesService = {
  getAll: async (): Promise<InvoiceSeriesDto[]> => {
    const response: AxiosResponse<ApiResponseDto<InvoiceSeriesDto[]>> = await apiClient.get(endpoints.series);

    if (response.data.errors) {
      throw new Error(response.data.errors.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },

  create: async (data: InvoiceSeriesCreateRequestDto): Promise<InvoiceSeriesDto> => {
    const response: AxiosResponse<ApiResponseDto<InvoiceSeriesDto>> = await apiClient.post(endpoints.series, data);

    if (response.data.errors) {
      throw new Error(response.data.errors.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },

  update: async (id: number, data: InvoiceSeriesUpdateRequestDto): Promise<InvoiceSeriesDto> => {
    const response: AxiosResponse<ApiResponseDto<InvoiceSeriesDto>> = await apiClient.put(endpoints.seriesById(id), data);

    if (response.data.errors) {
      throw new Error(response.data.errors.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },

  activate: async (id: number): Promise<InvoiceSeriesDto> => {
    const response: AxiosResponse<ApiResponseDto<InvoiceSeriesDto>> = await apiClient.post(endpoints.activate(id));

    if (response.data.errors) {
      throw new Error(response.data.errors.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },

  deactivate: async (id: number): Promise<InvoiceSeriesDto> => {
    const response: AxiosResponse<ApiResponseDto<InvoiceSeriesDto>> = await apiClient.post(endpoints.deactivate(id));

    if (response.data.errors) {
      throw new Error(response.data.errors.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },
};
